// Example FounderAssist weeks for the visitor homepage, keyed by the skill the
// visitor needs (data/skill-phrases.js keys). They illustrate the product;
// they aren't anyone's real plan, and the page labels them as examples.
export const SAMPLE_PLANS = {
  dev: {
    goal: "Get to a working prototype with a technical co-founder.",
    done: "Talk to five potential customers",
    next: ["Write the one-page pitch a developer would want to read", "Message three developers from your matches"],
    later: ["Turn the customer calls into a list of must-have features", "Agree how you'd split the work for the first month"],
  },
  biz: {
    goal: "Line up the first partners and customers.",
    done: "List twenty companies that feel this problem",
    next: ["Write the two-line intro a business developer could forward", "Message three business developers from your matches"],
    later: ["Draft the first partnership offer", "Pick the three accounts to pitch first"],
  },
  product: {
    goal: "Decide what to build first, with someone who owns the product.",
    done: "Write down the three problems users mention most",
    next: ["Sketch the first version on one page", "Message three product leads from your matches"],
    later: ["Cut the feature list to what fits in six weeks", "Set up five user interviews"],
  },
  mkt: {
    goal: "Find the first hundred users.",
    done: "Pick the one channel your users already spend time in",
    next: ["Draft the landing page headline", "Message three marketers from your matches"],
    later: ["Write the first three posts for that channel", "Set up a waitlist and measure sign-ups"],
  },
  sales: {
    goal: "Turn early interest into paying customers.",
    done: "List the ten warmest leads",
    next: ["Write the offer and the price", "Message three salespeople from your matches"],
    later: ["Book five discovery calls", "Write down every objection you hear"],
  },
  design: {
    goal: "Make the first version easy to use.",
    done: "Collect screenshots of tools your users already like",
    next: ["Write down the three screens the product needs", "Message three designers from your matches"],
    later: ["Test the paper version with three users", "Choose the one flow to polish first"],
  },
}
